"use client";

import React, { useContext } from "react";
import { FavouriteContext } from "./FavFunctionalityWrapper";
import dynamic from "next/dynamic";
import {
  DataLayerGA4AttrType,
  GA4EventAttrType,
} from "@packages/lib/types/datalayerGA";
import { ClickstreamInterface } from "@packages/lib/utlils/clickstream";
const FavouriteIcon = dynamic(() => import("./FavouriteHeartIcon"), {
  ssr: false,
});

interface UserFavouriteProps {
  contentType: "INSTITUTION" | "COURSE";
  contentId: number;
  contentName: string;
  statsGAData?: GA4EventAttrType;
  clickStreamData?: ClickstreamInterface;
  similaruni?: boolean;
  statsOldGAData?: DataLayerGA4AttrType;
}

const UserFavourite = ({
  contentId,
  contentType,
  contentName,
  statsGAData,
  clickStreamData,
  similaruni,
  statsOldGAData,
}: UserFavouriteProps) => {
  const { favourites, setFavourites, favourite } = useContext(FavouriteContext);
  return (
    <>
      <FavouriteIcon
        {...{
          contentId,
          contentType,
          contentName,
          favourites,
          setFavourites,
          favourite,
          statsGAData,
          clickStreamData,
          similaruni,
          statsOldGAData,
        }}
      />
    </>
  );
};

export default UserFavourite;
